import React from 'react'
import { Box, Typography, Divider, List, ListItemIcon, ListItem, ListItemText } from '@mui/material'
import HeadsetMicIcon from '@mui/icons-material/HeadsetMic'
import SupervisorAccountIcon from '@mui/icons-material/SupervisorAccount'
import GroupsIcon from '@mui/icons-material/Groups'
import NoteAltIcon from '@mui/icons-material/NoteAlt'

export const QuickLinksCard = () => {
  const quicklinks = [
    {
      itemText: 'IT Help Desk',
      url: 'https://htgroup-it.atlassian.net/servicedesk/customer/portal/2',
      icon: <HeadsetMicIcon />,
    },
    {
      itemText: 'HR Info-Tech',
      url: 'https://www.infotech-cloudhr.com.my/',
      icon: <GroupsIcon />,
    },
    {
      itemText: 'Microsoft Teams',
      url: 'https://teams.microsoft.com',
      icon: <SupervisorAccountIcon />,
    },
    {
      itemText: 'Marketing Request Form',
      url: 'https://forms.gle/9Wk8igJWtM5vDz9Q9',
      icon: <NoteAltIcon />,
    },
  ]
  return (
    <Box bgcolor='#fff' borderRadius={3} display='flex' width='100%' height='100%'>
      <Box display='flex' width='100%' flexDirection='column' p={5}>
        <Typography variant='h6'>Quicklinks</Typography>
        <Divider />
        <List>
          {quicklinks.map((link) => (
            <ListItem button component='a' href={link.url} target='_blank' key={link.itemText}>
              <ListItemIcon sx={{ color: '#999999' }}>{link.icon}</ListItemIcon>
              <ListItemText>{link.itemText}</ListItemText>
            </ListItem>
          ))}
        </List>
      </Box>
    </Box>
  )
}
